
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch-on-tv",
      function () {
        return require("private-next-pages/watch-on-tv/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watch-on-tv"])
      });
    }
  